export const humanize = key => String(key).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]/g, ' ').replace(/^./, c => c.toUpperCase());
const labels = { temperature: ['Temperatura', 'Temperature'], vibration: ['Vibrazione', 'Vibration'], rotationalSpeed: ['Velocità di rotazione', 'Rotational speed'], activePower: ['Potenza attiva', 'Active power'], pressure: ['Pressione', 'Pressure'] };
export function metrics(payload, rules = [], language = 'it') {
  const values = payload?.measurements || payload || {};
  if (!values || typeof values !== 'object') return [];
  return Object.entries(values).flatMap(([key, item]) => {
    const value = item && typeof item === 'object' ? item.value : item;
    if (!['number', 'string', 'boolean'].includes(typeof value)) return [];
    if (['schema', 'assetId', 'machineName', 'sequence', 'observedAt', 'simulationScenario', 'operatingState'].includes(key)) return [];
    const rule = rules.find(rule => rule.key === key);
    const unit = item?.unit || '';
    return [{ key, value, unit: unit === 'Cel' ? '°C' : unit, label: rule?.label || (typeof item?.label === 'string' && item.label) || labels[key]?.[language === 'it' ? 0 : 1] || humanize(key), level: metricLevel(value, unit, rule) }];
  });
}
export function metricLevel(value, unit, rule) {
  if (!rule) return 'unmonitored';
  if (typeof value !== 'number' || !Number.isFinite(value) || (rule.unit && rule.unit !== unit)) return 'offline';
  if (Number.isFinite(rule.criticalMin) && value < rule.criticalMin || Number.isFinite(rule.criticalMax) && value > rule.criticalMax) return 'alarm';
  if (Number.isFinite(rule.warningMin) && value < rule.warningMin || Number.isFinite(rule.warningMax) && value > rule.warningMax) return 'warning';
  return 'live';
}
export function validateRules(rules) {
  if (!Array.isArray(rules)) throw new Error('invalidAlarmRules');
  const seen = new Set();
  for (const rule of rules) {
    if (!rule || typeof rule.key !== 'string' || !rule.key.trim() || seen.has(rule.key)) throw new Error('invalidAlarmRules');
    seen.add(rule.key);
    for (const key of ['warningMin', 'warningMax', 'criticalMin', 'criticalMax']) if (rule[key] !== undefined && !Number.isFinite(rule[key])) throw new Error('invalidAlarmRules');
    for (const [low, high] of [['warningMin', 'warningMax'], ['criticalMin', 'criticalMax'], ['criticalMin', 'warningMin'], ['warningMax', 'criticalMax']]) if (Number.isFinite(rule[low]) && Number.isFinite(rule[high]) && rule[low] > rule[high]) throw new Error('invalidAlarmRules');
    if (!['warningMin', 'warningMax', 'criticalMin', 'criticalMax'].some(key => Number.isFinite(rule[key]))) throw new Error('invalidAlarmRules');
  }
  return rules;
}
const rank = { unmonitored: 0, live: 1, offline: 2, warning: 3, alarm: 4 };
export const worst = levels => levels.reduce((a, b) => rank[b] > rank[a] ? b : a, 'unmonitored');
export function alarmLevel(snapshot, rules = [], now = Date.now()) {
  const { status, latest, fetchedAt } = snapshot || {};
  if (!status?.connected || status.stale || !latest || now - (fetchedAt || 0) > 30000 || latest.encryption?.encrypted && !latest.encryption?.decrypted || latest.payload?.encrypted) return 'offline';
  const state = String(latest.payload?.operatingState || '').toLowerCase();
  const declared = ['alarm', 'critical', 'fault', 'error'].includes(state) ? 'alarm' : ['warning', 'degraded'].includes(state) ? 'warning' : 'unmonitored';
  const rows = metrics(latest.payload, rules);
  const missing = rules.some(rule => !rows.some(row => row.key === rule.key));
  return worst([declared, missing ? 'offline' : 'unmonitored', ...rows.map(row => row.level)]);
}
export function alarmTree(tree, document, snapshots, now = Date.now()) {
  const children = (tree.children || []).filter(node => node.type !== 'document').map(child => alarmTree(child, document, snapshots, now));
  const twin = document.twinIds?.[tree.id];
  const own = twin ? alarmLevel(snapshots?.[twin], document.configs?.[tree.id]?.alarmRules || [], now) : 'unmonitored';
  return { ...tree, children, status: worst([own, ...children.map(child => child.status)]) };
}
